<div class="flex pb-3">
  <p-fileupload
      name="demo[]"
      (uploadHandler)="uploadHandler($event)"
      (onSelect)="onSelect($event)"
      (onClear)="onClear($event)"
      [multiple]="false"
      accept=".pdf"
      [customUpload]="true"
      maxFileSize="10000000" 
      mode="advanced"
      class="w-full"
      chooseLabel="Seleccionar"
      uploadLabel="Subir"
      cancelLabel="Cancelar"
      invalidFileTypeMessageSummary="Tipo de archivo inválido"
      invalidFileTypeMessageDetail="'Tipo de archivos permitidos"
      invalidFileSizeMessageSummary="Tamaño de archivo no válido"
  >
    <ng-template #empty>
        <div>Arrastre archivos aqui para subir</div>
    </ng-template>
  </p-fileupload>
</div>
